import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const ReportLink = z.object({
    url: z.string(),
});

export type ReportLink = z.infer<typeof ReportLink>;
